module.exports = __webpack_public_path__ + "img/bus-sm-green.945b3134.svg";